import React from "react";

export default function PlaceholderTile({ className = "" }) {
  return (
    <div className={`w-full h-full flex flex-col items-center justify-center bg-sapore-purple ${className}`}>
      <div className="w-14 h-14 rounded-full bg-sapore-gold/20 flex items-center justify-center mb-2">
        <span className="text-sapore-gold text-2xl font-serif font-bold">S</span>
      </div>
      <span className="text-sapore-gold font-serif font-bold text-sm tracking-wide">SAPORE EATS</span>
      <span className="text-sapore-cream/70 text-[10px] tracking-[0.25em] mt-1">BREAKFAST &amp; CATERING</span>
    </div>
  );
}
